import { jsxs as o, jsx as l } from "react/jsx-runtime";
const t = (a) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M34.165 48.55v2c1.88 0 3.635-.849 4.807-2.296.365.194.748.363 1.148.502l.666-1.912a6.172 6.172 0 0 1-4.134-5.823h-2.025a8.197 8.197 0 0 0 2.701 6.077 4.243 4.243 0 0 1-3.163 1.451ZM49.547 30.919a5.482 5.482 0 0 0 .353-4.208 5.481 5.481 0 0 0-2.727-3.225l-.916 1.777a3.495 3.495 0 0 1 1.738 2.056 3.494 3.494 0 0 1-.225 2.683l1.777.917ZM34.97 15.062a5.485 5.485 0 0 0-4.076 1.102l1.22 1.584a3.522 3.522 0 0 1 4.934.638l1.584-1.22a5.48 5.48 0 0 0-3.661-2.104Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M53.707 19.387a14.808 14.808 0 0 0-6.9-4.26 13.972 13.972 0 0 0-3.948-5.085 13.923 13.923 0 0 0-8.694-3.058 13.794 13.794 0 0 0-9.818 4.067 13.788 13.788 0 0 0-4.063 9.513 8.714 8.714 0 0 0-2.139 1.361h-3.45l1.072 4h4.136a4.738 4.738 0 0 1 4.377-2.102V20.87c0-5.459 4.426-9.885 9.885-9.885 4.684 0 8.607 3.259 9.627 7.632 5.5.518 9.804 5.147 9.804 10.782 0 3.888-2.05 7.297-5.125 9.207a6.138 6.138 0 0 1-4.81 8.516c-1.194 4.118-4.993 7.128-9.496 7.128-5.202 0-9.466-4.019-9.856-9.122a4.743 4.743 0 0 1-5.068-5.819H9.876l1.072 4h4.66a8.787 8.787 0 0 0 5.348 5.347 13.856 13.856 0 0 0 3.751 5.875 13.838 13.838 0 0 0 9.458 3.72c3.07 0 5.979-.983 8.414-2.84a14.011 14.011 0 0 0 4.075-4.98 10.148 10.148 0 0 0 3.788-2.69 10.125 10.125 0 0 0 2.496-7.552 14.9 14.9 0 0 0 2.726-3.468 14.836 14.836 0 0 0 1.932-7.322c0-3.716-1.381-7.271-3.89-10.01Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M22.749 34.262H6.744l.536 2h16.005l-.536-2ZM27.203 29.35H10.166l.535 2H27.74l-.536-2Z"
        }
      )
    ]
  }
);
export {
  t as Smoke
};
